export enum StatutDeclaration {
  NON_TELECHARGEE = 'NON_TELECHARGEE',
  NON_DEPOSEE = 'NON_DEPOSEE',
  PARTIELLE = 'PARTIELLE',
  DEPOSEE = 'DEPOSEE',
}

export const STATUT_DECLARATION_DEPOTS = [
  StatutDeclaration.DEPOSEE,
  StatutDeclaration.PARTIELLE,
];